module.exports = __webpack_public_path__ + "static/img/public.e25a7e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/public.png
// module id = Dtxu
// module chunks = 0